module.exports = __webpack_public_path__ + "static/media/case-study-design-landscapes.50f55aca.pdf";